import React, { FC, useEffect } from 'react'

export const RegistrationForm16: FC = () => {
  useEffect(() => {
    window.close()
  }, [])

  return <div>Авторизация прошла успешно</div>
}

RegistrationForm16.displayName = 'RegistrationForm16'
